// import { Box, IconButton, Typography } from '@mui/material';
// import Grid from '@mui/material/Grid2';
// import { MdCorporateFare, MdOutlineAttachMoney, MdOutlineEdit, MdOutlineSupportAgent, MdSync } from 'react-icons/md';
// import Button from 'components/Common/Button';
// import DataTable from 'components/Common/DataTable';
// import Spinner from 'components/Common/Spinner';
// import { useNavigate } from 'react-router-dom';
// import { ColumnDef } from '@tanstack/react-table';
// import { RiDeleteBin6Line } from 'react-icons/ri';
// import { GoPlus } from 'react-icons/go';
// import { useDeleteBusiness, useGetAgencyPerformance, useGetBusinesses } from 'apis/agency/hook';
// import { BusinessProfileResponse } from 'apis/business/types';
// import * as urls from 'routes/config';
// import Modal from 'components/Common/Modal';
// import BusinessForm from './components/BusinessForm';
// import { useState } from 'react';
// import Pagination from 'components/Common/Pagination';
// import { formatCurrency } from 'utils/helperFunctions';
// import { CacheKeys } from 'utils/cacheKeys';
// import { useBusiness } from 'providers/context/BusinessProvider';

import { Box, Typography } from '@mui/material';

// export default function Dashboard() {
//   const navigate = useNavigate();
//   const [currentPage, setCurrentPage] = useState(1);
//   const { data: businesses, isLoading } = useGetBusinesses(currentPage);
//   const { mutateAsync: deleteBusiness } = useDeleteBusiness();
//   const { setSelectedBusiness, setSelectedWorkspace } = useBusiness();

//   const { data: agencyPerformance, isLoading: isAgencyPerformanceLoading } = useGetAgencyPerformance();

//   const handleEditBusiness = (business: BusinessProfileResponse) => {
//     if (business) {
//       setSelectedBusiness(Number(business.id));
//       setSelectedWorkspace(Number(business?.workspaces?.[0].id));
//       localStorage.setItem(CacheKeys.businessIds, JSON.stringify([business.id]));
//       localStorage.setItem(CacheKeys.workspaceIds, JSON.stringify(business?.workspaces?.map((item) => item.id)));
//       navigate(urls.agency.businessProfileEdit(String(business.id)));
//     }
//   };
//   if (isAgencyPerformanceLoading) {
//     return <Spinner />;
//   }

//   return (
//     <Box>
//       <Typography variant='h6' mb={3}>
//         Performance
//       </Typography>
//       <Grid container spacing={3}>
//         <Grid size={3} bgcolor='#fff' border='1px solid #ECECEC' paddingY={3} paddingX={2} borderRadius='4px'>
//           <Box display='flex' gap='4px' alignItems='center'>
//             <Box
//               bgcolor='#EAE6FD'
//               borderRadius='50%'
//               height='32px'
//               width='32px'
//               display='flex'
//               alignItems='center'
//               justifyContent='center'
//             >
//               <MdCorporateFare color='#4B22A8' fontSize={20} />
//             </Box>
//             <Typography color='secondary' fontWeight={500}>
//               Total Business
//             </Typography>
//           </Box>
//           <Typography variant='h5' mt={5} fontWeight={500}>
//             {agencyPerformance?.total_businesses}
//           </Typography>
//         </Grid>
//         <Grid size={3} bgcolor='#fff' border='1px solid #ECECEC' paddingY={3} paddingX={2} borderRadius='4px'>
//           <Box display='flex' gap='4px' alignItems='center'>
//             <Box
//               bgcolor='#EAE6FD'
//               borderRadius='50%'
//               height='32px'
//               width='32px'
//               display='flex'
//               alignItems='center'
//               justifyContent='center'
//             >
//               <MdOutlineSupportAgent color='#4B22A8' fontSize={20} />
//             </Box>
//             <Typography color='secondary' fontWeight={500}>
//               Total Agents
//             </Typography>
//           </Box>
//           <Typography variant='h5' mt={5} fontWeight={500}>
//             {agencyPerformance?.total_agents}
//           </Typography>
//         </Grid>
//         <Grid size={3} bgcolor='#fff' border='1px solid #ECECEC' paddingY={3} paddingX={2} borderRadius='4px'>
//           <Box display='flex' gap='4px' alignItems='center'>
//             <Box
//               bgcolor='#EAE6FD'
//               borderRadius='50%'
//               height='32px'
//               width='32px'
//               display='flex'
//               alignItems='center'
//               justifyContent='center'
//             >
//               <MdOutlineAttachMoney color='#4B22A8' fontSize={20} />
//             </Box>
//             <Typography color='secondary' fontWeight={500}>
//               Revenue from last month
//             </Typography>
//           </Box>
//           <Typography variant='h5' mt={5} fontWeight={500}>
//             {formatCurrency(agencyPerformance?.last_month_revenue)}
//           </Typography>
//         </Grid>
//         <Grid size={3} bgcolor='#fff' border='1px solid #ECECEC' paddingY={3} paddingX={2} borderRadius='4px'>
//           <Box display='flex' gap='4px' alignItems='start'>
//             <Box
//               bgcolor='#EAE6FD'
//               borderRadius='50%'
//               height='32px'
//               width='32px'
//               display='flex'
//               alignItems='center'
//               justifyContent='center'
//             >
//               <MdSync color='#4B22A8' fontSize={20} />
//             </Box>
//             <Typography color='secondary' fontWeight={500}>
//               Monthly Recurring Revenue
//             </Typography>
//           </Box>
//           <Typography variant='h5' mt={3} fontWeight={500}>
//             {formatCurrency(agencyPerformance?.montly_recurring_revenue)}
//           </Typography>
//         </Grid>
//       </Grid>

//       <Box display='flex' justifyContent='space-between' alignItems='center' mb={2} mt={3}>
//         <Typography variant='h2' fontWeight={500}>
//           Businesses
//         </Typography>
//         <Modal
//           button={(openModal: any) => (
//             <Button onClick={() => openModal()} variant='contained' color='primary' startIcon={<GoPlus />}>
//               Add Business
//             </Button>
//           )}
//         >
//           {(handleCloseModal: any) => <BusinessForm handleClose={handleCloseModal} />}
//         </Modal>
//       </Box>
//       <DataTable
//         data={businesses?.data}
//         columns={columns(deleteBusiness, handleEditBusiness)}
//         isHeaderSticky={true}
//         isLoading={isLoading}
//       />
//       <Pagination totalPages={businesses?.meta?.total_pages} currentPage={currentPage} onChange={setCurrentPage} />
//     </Box>
//   );
// }

// type DeleteBusinessFn = (id: number) => void;

// const columns = (deleteBusiness: DeleteBusinessFn, handleEditBusiness: any): ColumnDef<BusinessProfileResponse>[] => [
//   {
//     header: 'Name',
//     accessorKey: 'name'
//   },
//   {
//     header: 'Email',
//     accessorKey: 'email'
//   },
//   {
//     header: 'AGENTS',
//     accessorKey: 'agents_count'
//   },
//   {
//     header: 'BILLING STATUS',
//     cell: (info) => (
//       <Typography
//         sx={{
//           color: info.row.original.billing_status ? '#00860D' : '#FB8703',
//           border: info.row.original.billing_status ? '1px solid #00860D' : '1px solid #FB8703',
//           borderRadius: '8px',
//           padding: '4px 8px',
//           width: 'fit-content',
//           fontSize: '12px'
//         }}
//       >
//         {info.row.original.billing_status ? 'BILLED' : 'PENDING'}
//       </Typography>
//     )
//   },
//   {
//     header: 'Action',
//     cell: (info) => (
//       <Box display='flex' gap={1}>
//         <IconButton onClick={() => handleEditBusiness(info.row.original)}>
//           <MdOutlineEdit />
//         </IconButton>
//         <IconButton onClick={() => deleteBusiness(info.row.original.id)} color='error'>
//           <RiDeleteBin6Line style={{ color: 'red' }} />
//         </IconButton>
//       </Box>
//     )
//   }
// ];

export default function Dashboard() {
  return (
    <Box
      minHeight='70vh'
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      textAlign='center'
      px={2}
    >
      <Typography variant='h2' fontWeight='bold' color='primary' gutterBottom>
        Coming Soon
      </Typography>
      <Typography variant='body1' color='textSecondary' maxWidth={400} mb={4}>
        We're working hard to bring you something amazing. Stay tuned!
      </Typography>
    </Box>
  );
}
